import { getLocalValue, LoacalVariables } from "./CommonFunctions";
import { getMenu } from "../Components/Dashboard/menu";
import { isStaffAccount } from "./staffAccess";

const firstPath = (items: any[]): string | undefined => {
  for (const item of items) {
    const found = item.path || (item.children && firstPath(item.children));
    if (found) return found;
  }
  return undefined;
};

// Landing page after login, based on the logged-in vendor's type:
// pharmacy users land on Pharmacy Orders, lab users on Lab Orders.
// Staff land on the first page they have access to.
export const getHomePath = () => {
  const userType = getLocalValue(LoacalVariables.UserType);
  if (isStaffAccount()) {
    const first = firstPath(getMenu(userType).staticMenu);
    if (first) return first;
  }
  return userType === "pharmacy" ? "/pharmacy-orders/list" : "/lab-orders/list";
};
